import React from 'react'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useNavigate } from 'react-router-dom';
const AccountSuccessModal = ({ show, handleClose }) => {
  const Navigate = useNavigate();
  const email = localStorage.getItem("email")
  return (
    <Modal show={show}>
      <Modal.Body>
        <div>
          <div className="account-created-pop">
            {/* <h3> */}
            {/* Account Created Successfully */}
            {/* Success
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="34"
                height="34"
                viewBox="0 0 34 34"
                fill="none"
              >
                <rect
                  width="30"
                  height="30"
                  rx="15"
                  transform="matrix(-1 0 0 1 32 2)"
                  stroke="#337FE0"
                  strokeWidth="3"
                />
                <path
                  d="M23.5625 13.516L14.4916 21.2188L10.4375 17.1647"
                  stroke="#337FE0"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </h3> */}
            <div className="success-btn">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="80"
                height="80"
                viewBox="0 0 34 34"
                fill="green"
              >
                <rect
                  width="30"
                  height="30"
                  rx="15"
                  transform="matrix(-1 0 0 1 32 2)"
                  stroke="white"
                  strokeWidth="3"
                />
                <path
                  d="M23.5625 13.516L14.4916 21.2188L10.4375 17.1647"
                  stroke="white"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            <h2>
              {/* Thank you for registering and confirming your account! */}
              Success!
            </h2>
            <p>
              {/* Where would you like to go now? */}
              Thank you for registering. <br /> What would you like to do next?
            </p>
          </div>
        </div>
        <div className="account-created-action">
          <button
            onClick={() => {
              localStorage.setItem("email", "");
              localStorage.setItem("userId", "");
              Navigate("/leads");
            }}
            className="btn-outline"
          >
            {/* View Leads */}
            Return to Web
          </button>
          {/* <button
          onClick={() => {
            localStorage.setItem("email", "");
            localStorage.setItem("userId", "");
            Navigate("/my-profile")
          }}
          className="btn-fill"
        >
          Update my Profile 


        </button> */}

          <button
            onClick={() => {
              const userAgent =
                navigator.userAgent || navigator.vendor || window.opera;

              const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
              const isAndroid = /Android/i.test(userAgent);

              if (isIOS) {
                window.open(
                  "https://apps.apple.com/app/instagram/id389801252",
                  "_blank"
                );
              } else if (isAndroid) {
                window.open(
                  "https://play.google.com/store/apps/details?id=com.instagram.android",
                  "_blank"
                );
              } else {
                alert("Please use your mobile device to download the app.");
              }
            }}
            className="btn-fill"
          >
            Download our App
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default AccountSuccessModal
